import "./MenuBar.css"
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MenuBar (props) {
    const { t, i18n } = useTranslation();

    const changetoGermanHandler = () => {
      const languageValue = "de";
      i18n.changeLanguage(languageValue);
    }

    const changetoEnglishHandler = () => {
        const languageValue = "en";
        i18n.changeLanguage(languageValue);
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark p-0" style={{background: "#2d3d57"}}>
            <div className="container-fluid menubar">
                <div style={{display: "flex"}}>
                    <img src="https://bisonaire.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/de.png" alt="German" width="20" height="15" onClick={changetoGermanHandler}></img>
                    <img src="https://bisonaire.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/en.png" alt="English" width="20" height="15" onClick={changetoEnglishHandler} style={{marginRight: "2rem"}} ></img>
                </div>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <NavLink className="nav-link" to="/">{t("case")}</NavLink>
                        <NavLink className="nav-link" to="/1">1. {t("pnp")}</NavLink>
                        <NavLink className="nav-link" to="/2">2. {t("deductions")}</NavLink>
                        <NavLink className="nav-link" to="/3">3. {t("kpis")}</NavLink>
                        <NavLink className="nav-link" to="/4">4. {t("brb")}</NavLink>
                        <NavLink className="nav-link" to="/5">5. {t("conclusion")}</NavLink>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default MenuBar;